// extracted by mini-css-extract-plugin
module.exports = {"img":"PictureDialog_img__pfW8k"};